import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";
import { IIcon } from "./icons-interfaces";

const ActivateSvg = () => (
  <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
    <path d="M11.01,43.55c-.64,0-1.27-.17-1.85-.51-1.13-.66-1.81-1.83-1.81-3.14V9.27c0-1.3.68-2.48,1.81-3.14,1.15-.67,2.52-.68,3.67-.02l26.98,15.32c1.16.66,1.84,1.84,1.84,3.16s-.69,2.5-1.84,3.16l-26.98,15.32h0c-.57.32-1.2.49-1.82.49ZM11.84,41.32h0,0ZM11.35,9.87v29.43l25.92-14.72L11.35,9.87Z" />
  </svg>
);

const ActivateIcon: FunctionComponent<IIcon> = (props): JSX.Element => (
  <Icon className={props.className} component={ActivateSvg} />
);

export default ActivateIcon;
